import { useSearchParams } from "react-router-dom";
import {React, useEffect, useState} from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { getFirestore, doc, setDoc, getDoc, updateDoc, serverTimestamp, increment } from "firebase/firestore";
import emailjs from "emailjs-com";

const db = getFirestore();


const PaymentSuccess = () => {
    const navigate = useNavigate();  
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const [eventType, setEventType] = useState("Fetching...");

    const [isGift2, setIsGift] = useState(false);
    const [recipientName2, setRecipientName] = useState("");
    
    
    // const userId = searchParams.get("userId");
    // const consultantId = searchParams.get("consultantId");
    // const amount = parseFloat(searchParams.get("amount"));
    



    useEffect(() => {
      const fetchSessionDetails = async () => {
        if (!sessionId) return;

        try {
              const response = await fetch(`/api/get-session?session_id=${sessionId}`);
              const data = await response.json();

              // Then extract these from Stripe metadata:
              const userId = data.metadata.userId;
              const consultantId = data.metadata.consultantId;
              const amount = parseFloat(data.metadata.amount);
              const isGift = data.metadata.isGift === "true";
              const recipientEmail = data.metadata.recipientEmail || null;
              const recipientName = data.metadata.recipientName || null;
              const senderName = data.metadata.senderName || null;
              const myamount = parseFloat(data.metadata.myamount)
              // console.log('data: ', data)

              // TODO: useramount is string and stored as string in db

              // const fullAmount = parseFloat(data.metadata.amount);
              // const userAmount1 = amount * 0.9; // Deduct 10% platform commission
              const userAmount1 = myamount
              const userAmount = parseFloat(userAmount1.toFixed(2));
              setIsGift(isGift);
              setRecipientName(recipientName);
              

              if (data.eventType) {
                  console.log("Last Stripe Event:", data.eventType);
                  setEventType(data.eventType);
              } else {
                  console.log("No event type found.");
              }
              

            if (isGift && recipientEmail) {
                // Store gift card in Firestore
                const giftRef = doc(db, "giftCards", sessionId); // use Stripe sessionId as unique ID
                await setDoc(giftRef, {
                  recipientEmail,
                  recipientName,
                  senderName,
                  amount:userAmount,
                  senderId: userId,
                  status: "unclaimed",
                  createdAt: serverTimestamp()
                });
                console.log("Gift card stored for", recipientEmail);

                // send gift card alert to mail
                  await emailjs.send(
                        'service_kxsob6t', 
                        'template_10zwqo1', 
                        {
                        recipientEmail: recipientEmail,
                        recipientName: recipientName,
                        amount:userAmount,
                        senderName:senderName
                      
                      }, 'iTUAGGcFXyrJu_f0s');

                      const payRef = doc(db, "priest_recharged", userId);
                      // const paySnap = await getDoc(payRef)


                      //   if (paySnap.exists()) {
                      //     const prevAmount = paySnap.data().totalAmountPaid || 0;
                      //     const prevCredit = paySnap.data().totalCredit || 0;
                      //     await updateDoc(payRef, {
                      //       totalAmountPaid: prevAmount + amount,
                      //       totalCredit: prevCredit + userAmount,
                      //       lastPaidAt: serverTimestamp(),
                      //       count: increment(1)
                      //     });
                      //   } else {
                      //     await setDoc(payRef, {
                      //       totalAmountPaid: amount,
                      //       totalCredit: userAmount,
                      //       lastPaidAt: serverTimestamp(),
                      //       count: 1
                      //     });
                      //   }

                      try {
                          // Use setDoc with merge so it works for both new & existing docs without overwriting
                          await setDoc(payRef, {
                            totalAmountPaid: increment(amount),
                            totalCredit: increment(userAmount),
                            lastPaidAt: serverTimestamp(),
                            count: increment(1)
                          }, { merge: true });

                          console.log("Payment data updated successfully.");
                        } catch (error) {
                          console.error("Error updating payment:", error);
                        }

                      console.log("data updated successfully.");

              } else {
                // ✅ Update Firestore with the payment
                // const credRef = doc(db, "priest_users", userId);
                // const credSnap = await getDoc(credRef);

                // if (credSnap.exists()) {
                //   const prevAmount = credSnap.data().credits || 0;
                //   await updateDoc(credRef, {
                //     credits: prevAmount + amount,
                //     // lastPaidAt: serverTimestamp()
                //   });
                // } else {
                //   await setDoc(credRef, {
                //     credits: amount,
                //     // lastPaidAt: serverTimestamp()
                //   });
                // }

                // console.log("credits updated successfully.");

                const payRef = doc(db, "priest_recharged", userId);
                // const paySnap = await getDoc(payRef)


                // if (paySnap.exists()) {
                //     const prevAmount = paySnap.data().totalAmountPaid || 0;
                //     const prevCredit = paySnap.data().totalCredit || 0;
                //     await updateDoc(payRef, {
                //       totalAmountPaid: prevAmount + amount,
                //       totalCredit: prevCredit + userAmount,
                //       lastPaidAt: serverTimestamp(),
                //       count: increment(1)
                //     });
                //   } else {
                //     await setDoc(payRef, {
                //       totalAmountPaid: amount,
                //       totalCredit: userAmount,
                //       lastPaidAt: serverTimestamp(),
                //       count: 1
                //     });
                //   }
                try {
                    // Use setDoc with merge so it works for both new & existing docs without overwriting
                    await setDoc(payRef, {
                      totalAmountPaid: increment(amount),
                      totalCredit: increment(userAmount),
                      lastPaidAt: serverTimestamp(),
                      count: increment(1)
                    }, { merge: true });

                    console.log("Payment data updated successfully.");
                  } catch (error) {
                    console.error("Error updating payment:", error);
                  }

                console.log("data updated successfully.");
              }
          } catch (error) {
              console.error("Error fetching session details:", error);
          }
      };

      fetchSessionDetails();
  }, [sessionId]);


    return (
        <Container className="text-center mt-5">
              <Row className="justify-content-center">
                <Col md={6}>
                  <FaCheckCircle size={60} className="text-success mb-3" />
                  <h2 className="text-success">Payment Successful</h2>
                  {isGift2 ? (
                      <p className="text-muted">
                        Gift sent successfully! <strong>{recipientName2}</strong> has been contacted. Thank you.
                      </p>
                    ) : (
                      <p className="text-muted">
                        Your payment is successful! You can now pay Priests with your cowries.
                        <img
                          src="/cowrieblack.png"
                          alt="Cowrie Icon"
                          style={{ width: '20px', height: '20px', marginLeft: '8px' }}
                        />
                      </p>
                    )}
                  {/* <p><strong>Last Stripe Event:</strong> {eventType}</p> */}
                  {/* <Button variant="primary" onClick={() => navigate("/checkout")}>
                    Retry Payment
                  </Button> */}
                  <Button variant="link" className="mt-3" onClick={() => navigate("/")}>
                    Go Home
                  </Button>
                </Col>
              </Row>
            </Container>
    );
}

export default PaymentSuccess;
